import { LuBug, LuBuilding2, LuClipboardList, LuClock, LuCode, LuCpu, LuPalette, LuRocket, LuShoppingBag, LuSmartphone, LuUsers, LuWallet } from "react-icons/lu";

export const SurveyIntelligenceHeroData = {
  backgroundImage: "/images/serviceBanners/OnsiteSurveys.webp",
  whiteImage: "/images/serviceBanners/OnsiteSurveysW.webp",
  subTitle: "Onsite Surveys & Feedback Intelligence Services",
  title: (
    <>
      High Performance <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-600">Customer Insight</span>
      <br /> Systems
    </>
  ),
  description:
    "Onsite surveys and feedback intelligence systems designed to capture real time customer insights, analyze user behavior, and support data driven decision making through structured feedback collection at physical touchpoints.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Onsite Survey Strategy",
      desc: "Structured feedback capture strategy at target locations.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Real Time Feedback Collection",
      desc: "Instant customer experience and satisfaction feedback mapping.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Customer Experience Analysis",
      desc: "Deconstruct feedback to identify improvement areas in service & products.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Data Driven Insight System",
      desc: "Agile processing workflows to map data into growth roadmaps.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "22%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const surveyIntelligenceAboutData = [
  {
    title: "Customer Feedback Management Services for Better Business Decisions",
    content: (
      <>
        Understanding customer expectations is essential for improving products, services, and overall business performance. Professional Customer Feedback Management Services help
        organizations collect valuable insights directly from customers, allowing businesses to make informed decisions based on real experiences. Many companies rely on
        assumptions instead of actual feedback, which can lead to missed opportunities and lower customer satisfaction. At Tycho Technologies, feedback systems are designed to
        capture meaningful customer perspectives that support continuous improvement and long term business growth.
      </>
    ),
  },
  {
    title: "Customer Survey Services That Capture Meaningful Insights",
    content: (
      <>
        Effective customer research begins with asking the right questions at the right time. Reliable Customer Survey Services help businesses gather accurate information about
        customer preferences, satisfaction levels, and expectations. Organizations that invest in structured survey programs often gain a clearer understanding of what influences
        customer decisions and loyalty. Tycho Technologies develops customized survey frameworks that help businesses collect actionable information while improving response
        quality and participation rates.
      </>
    ),
  },
  {
    title: "Customer Experience Management Services for Continuous Improvement",
    content: (
      <>
        Creating exceptional customer experiences requires ongoing evaluation and refinement. Professional Customer Experience Management Services help organizations identify
        strengths, uncover service gaps, and improve interactions across every customer touchpoint. Businesses that actively analyze customer experiences often achieve stronger
        retention and higher satisfaction because improvements are based on real customer feedback. A structured experience management approach helps companies align services with
        evolving customer needs and expectations.
      </>
    ),
  },
  {
    title: "Why Businesses Invest in Customer Insights & Analytics Services",
    content: (
      <>
        The demand for Feedback Collection Services continues to grow as businesses seek reliable ways to understand customer behavior and market expectations. Companies investing
        in Customer Insights & Analytics Services often focus on improving decision making, increasing customer satisfaction, and strengthening operational efficiency. Businesses
        partnering with Tycho Technologies gain access to customized feedback intelligence frameworks designed around measurable business objectives and customer needs. A strategic
        approach to feedback analysis helps organizations uncover growth opportunities, improve service quality, and create stronger customer relationships over time.
      </>
    ),
  },
];

export const surveyIntelligenceDevelopSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Onsite Surveys & Feedback Intelligence Solutions for Every Business Requirement",
  buildCards: [
    {
      title: "Onsite Survey Design & Execution",
      desc: "Create structured survey systems to capture customer feedback at stores, events, and physical locations.",
      icon: LuSmartphone,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Real Time Feedback Collection",
      desc: "Collect instant responses from customers to understand experience and satisfaction levels.",
      icon: LuClock,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Customer Experience Analysis",
      desc: "Analyze feedback data to identify improvement areas in service, product, and engagement.",
      icon: LuBuilding2,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Behavioral Insight Mapping",
      desc: "Understand customer behavior patterns to improve business strategy and decision making.",
      icon: LuUsers,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Performance Reporting System",
      desc: "Generate structured reports based on feedback trends and customer satisfaction metrics.",
      icon: LuWallet,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Actionable Insight Optimization",
      desc: "Convert collected data into actionable strategies for better customer experience and growth.",
      icon: LuCpu,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Onsite Surveys & Feedback Intelligence Framework",
  processTitle: "How We Build Scalable Customer Insight Systems",
  processSteps: [
    {
      step: "01",
      title: "Insight Strategy Planning",
      description: "Define survey goals, customer touchpoints, and feedback collection strategy.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Agile Data Collection Execution",
      description: "Run continuous feedback collection cycles across physical locations and events.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Survey System Development",
      description: "Create structured survey flows for capturing meaningful customer insights.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Data Processing & Analysis",
      description: "Convert raw feedback into structured insights for decision making.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Performance Insight Optimization",
      description: "Improve data quality, response rate, and insight accuracy using analysis.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Quality Assurance & Validation",
      description: "Ensure accuracy, reliability, and consistency of collected feedback data.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY INVEST IN FEEDBACK INTELLIGENCE SYSTEMS?",
  benefitsTitle: "Why Businesses Invest in Feedback Intelligence Systems",
  benefits: [
    "Better customer experience understanding",
    "Real time decision making capability",
    "Improved service quality insights",
    "Data driven business improvements",
    "Strong customer satisfaction tracking",
    "Scalable feedback collection system",
    "Higher operational efficiency",
  ],
  logoImage: "/images/serviceBanners/DigitalMarketingLatest.webp",
  whiteLogoImage: "/images/serviceBanners/digitalMarketingLatestW.webp",
};

export const surveyIntelligenceServices = [
  {
    icon: <LuSmartphone size={36} />,
    title: "Customer Surveys",
    description: "Launch structured survey systems at physical storefronts, retail counters, and digital kiosks.",
    image: "/images/MobileAppDevelopment/Android-Development.png",
    link: "/onsite-surveys-feedback-intelligence-services-india#customer-surveys",
  },
  {
    icon: <LuBuilding2 size={36} />,
    title: "Behavioral Mapping",
    description: "Collect real-time satisfaction feedback at corporate touchpoints to deconstruct service drop-offs.",
    image: "/images/MobileAppDevelopment/iOS-Custom.png",
    link: "/onsite-surveys-feedback-intelligence-services-india#behavioral-mapping",
  },
  {
    icon: <LuCpu size={36} />,
    title: "Feedback Reporting Dashboards",
    description: "Build robust data pipelines that stream feedback reports into custom executive insights tables.",
    image: "/images/MobileAppDevelopment/Hybrid-Dev.png",
    link: "/onsite-surveys-feedback-intelligence-services-india#feedback-dashboards",
  },
];

export const surveyIntelligenceFaqData = [
  {
    q: "What is Feedback Intelligence and how does it help corporate performance?",
    a: "Feedback Intelligence is the systematic collection and analysis of customer responses from physical touchpoints. It replaces assumptions with data, helping managers identify customer pain points, improve customer experiences, and align corporate strategies with actual expectations.",
  },
  {
    q: "How can onsite surveys be integrated into physical outlets?",
    a: "We design surveys that can be deployed via custom QR codes, digital kiosks, tablet setups at counters, or geo-triggered mobile links. This makes it effortless for customers to provide feedback immediately after a purchase or interaction.",
  },
  {
    q: "What metrics are tracked in the Feedback Reporting System?",
    a: "We track key satisfaction indicators such as Net Promoter Score (NPS), Customer Satisfaction Score (CSAT), Service Quality Ratings, response rates, and text-based feedback sentiment trends over time.",
  },
  {
    q: "Can Tycho Technologies assist with converting raw survey responses into actionable strategies?",
    a: "Yes. Our engineering framework includes a data processing and analysis engine. We categorize qualitative comments and analyze trend data to deliver structured reports with strategic recommendations for service and product optimization.",
  },
];

export const surveyIntelligencePortfolioData = {
  subtitle: "OUR WORK",
  title: "Feedback Projects We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};
